import React from "react";
import Page from "../../components/page/Page";
import PageHeader from "../../features/page-header/PageHeader";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import { Upload } from "../../components/upload/Upload";
import Icon from "@amzn/meridian/icon";
import infoKnockoutTokens from "@amzn/meridian-tokens/base/icon/info-knockout";
import { Space } from "../../components/space/Space";
import Column from "@amzn/meridian/column";
import { TableComponent } from "../../components/table/TableComponent";

export const AddMail: React.FC = () => {
    const acceptedFileTypes = ["application/pdf"].join(",");

    return (
        <Page
            type="form"
            title={"Add mail"}
            description={undefined}
            hasBreadcrumbs={true}
            actions={null}
        >
            <PageHeader />
            <Space size={"m"} />
            <Row spacing={"none"} alignmentVertical={"top"}>
                <Upload
                    useCase={"FILE_UPLOAD"}
                    s3Prefix={"public/"}
                    acceptedFileTypes={acceptedFileTypes}
                />
                <Box type="fill" width={"25rem"} spacingInset="500">
                    <>
                        <Row>
                            <Icon tokens={infoKnockoutTokens} />
                            <Text type="h300">Add mails manually</Text>
                        </Row>
                        <Space size={"xs"} />
                        <Text type="b300">
                            After the mails are uploaded, information in these mails will be
                            extracted automatically.
                        </Text>
                    </>
                </Box>
            </Row>
            <Column>
                <Text type="h200">File upload history</Text>
                <TableComponent
                    onSearch={false}
                    tableName={"audit-records-mails"}
                    tableQueryParams={{
                        eventUseCase: "FILE_UPLOAD",
                        businessUseCase: "SMART",
                        exclusiveStartKey: null,
                    }}
                />
            </Column>
        </Page>
    );
};
